// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.scorecard-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 20px;
  padding: 0 10px;
}

.scorecard {
  background: linear-gradient(135deg, #0b2545 0%, #134e73 100%);
  color: #ffffff;
  padding: 30px 25px;
  border-radius: 16px;
  margin-bottom: 20px;
  width: 100%;
  max-width: 650px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3);
  border: 1px solid rgba(255, 255, 255, 0.1);
}

.scorecard.night-mode {
  background: linear-gradient(135deg, #1a1a1a 0%, #2d2d2d 100%);
  border: 1px solid rgba(255, 255, 255, 0.05);
}

.scorecard-header {
  margin-bottom: 25px;
}

.scorecard h2 {
  text-align: center;
  color: #f5a623;
  font-size: 28px;
  font-weight: 700;
  margin-bottom: 20px;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
  letter-spacing: 0.5px;
}

.scorecard-meta {
  display: flex;
  justify-content: space-around;
  background: rgba(255, 255, 255, 0.08);
  padding: 15px 20px;
  border-radius: 10px;
  border: 1px solid rgba(255, 255, 255, 0.15);
  margin-bottom: 5px;
}

.meta-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
}

.meta-label {
  font-size: 12px;
  color: rgba(255, 255, 255, 0.7);
  font-weight: 500;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.meta-value {
  font-size: 16px;
  font-weight: 700;
  color: #f5a623;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.3);
}

.scorecard-content {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.match-row {
  background: rgba(255, 255, 255, 0.05);
  padding: 16px 20px;
  border-radius: 12px;
  border: 1px solid rgba(255, 255, 255, 0.1);
  transition: all 0.3s ease;
}

.match-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
  padding-bottom: 8px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
}

.match-header-simple {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin-bottom: 8px;
}

.match-date {
  font-size: 13px;
  color: rgba(255, 255, 255, 0.8);
  font-weight: 500;
}

.point-diff {
  font-size: 12px;
  color: #f5a623;
  font-weight: 600;
  background: rgba(245, 166, 35, 0.2);
  padding: 2px 8px;
  border-radius: 12px;
  border: 1px solid rgba(245, 166, 35, 0.3);
}

.match-teams {
  display: grid;
  grid-template-columns: 2fr auto 2fr;
  align-items: center;
  gap: 8px;
}

.match-row:hover {
  background: rgba(255, 255, 255, 0.08);
  transform: translateY(-2px);
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.2);
}

.team {
  display: flex;
  align-items: center;
  min-width: 0; /* Allows flex items to shrink below their content size */
  max-width: 100%;
}

.team-a {
  justify-content: flex-end;
  padding-right: 8px;
}

.team-b {
  justify-content: flex-start;
  padding-left: 8px;
}

.team-name {
  font-weight: 600;
  font-size: 12px;
  line-height: 1.2;
  max-width: 100%;
  color: #ffffff;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.3);
  word-break: break-word;
  hyphens: auto;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-align: center;
}

.team.winner .team-name {
  color: #f5a623;
  font-weight: 700;
}

.scores {
  display: flex;
  gap: 12px;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
}

.scores span {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  background-color: rgba(255, 255, 255, 0.9);
  color: #0b2545;
  font-weight: 700;
  font-size: 16px;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
  transition: all 0.3s ease;
}

.scores .winning-score {
  background: linear-gradient(135deg, #f5a623 0%, #ff8c42 100%);
  color: #ffffff;
  box-shadow: 0 4px 12px rgba(245, 166, 35, 0.4);
  transform: scale(1.1);
}

.night-mode .scores span {
  background-color: rgba(255, 255, 255, 0.1);
  color: #ffffff;
  border: 1px solid rgba(255, 255, 255, 0.2);
}

.night-mode .scores .winning-score {
  background: linear-gradient(135deg, #f5a623 0%, #ff8c42 100%);
  color: #ffffff;
  border: none;
}

.download-button {
  background: linear-gradient(135deg, #4CAF50 0%, #45a049 100%);
  color: white;
  border: none;
  padding: 14px 28px;
  text-align: center;
  text-decoration: none;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  font-weight: 600;
  margin: 8px 0;
  cursor: pointer;
  border-radius: 12px;
  transition: all 0.3s ease;
  box-shadow: 0 4px 16px rgba(76, 175, 80, 0.3);
  letter-spacing: 0.5px;
}

.download-button:hover {
  background: linear-gradient(135deg, #45a049 0%, #3d8b40 100%);
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(76, 175, 80, 0.4);
}

.download-button:active {
  transform: translateY(0);
  box-shadow: 0 2px 8px rgba(76, 175, 80, 0.3);
}

.night-mode .download-button {
  background: linear-gradient(135deg, #45a049 0%, #3d8b40 100%);
  box-shadow: 0 4px 16px rgba(69, 160, 73, 0.4);
}

.night-mode .download-button:hover {
  background: linear-gradient(135deg, #4CAF50 0%, #45a049 100%);
  box-shadow: 0 6px 20px rgba(76, 175, 80, 0.5);
}

/* Responsive design for smaller screens */
@media (max-width: 480px) {
  .scorecard {
    padding: 20px 15px;
    margin: 0 5px 20px 5px;
  }
  
  .scorecard h2 {
    font-size: 24px;
    margin-bottom: 15px;
  }
  
  .scorecard-meta {
    flex-direction: column;
    gap: 12px;
    padding: 12px 15px;
  }
  
  .meta-item {
    flex-direction: row;
    justify-content: space-between;
    width: 100%;
  }
  
  .meta-label {
    font-size: 11px;
    text-transform: none;
    color: rgba(255, 255, 255, 0.8);
  }
  
  .meta-value {
    font-size: 14px;
  }
  
  .match-row {
    padding: 12px 15px;
  }
  
  .match-header {
    margin-bottom: 10px;
    padding-bottom: 6px;
  }
  
  .match-header-simple {
    margin-bottom: 6px;
  }
  
  .match-date {
    font-size: 12px;
  }
  
  .point-diff {
    font-size: 11px;
    padding: 2px 6px;
  }
  
  .team-name {
    font-size: 11px;
  }
  
  .scores span {
    width: 32px;
    height: 32px;
    font-size: 14px;
  }
  
  .team-a {
    padding-right: 6px;
  }
  
  .team-b {
    padding-left: 6px;
  }
  
  .match-teams {
    gap: 6px;
  }
  
  .download-button {
    padding: 12px 24px;
    font-size: 15px;
  }
}

/* Medium screen adjustments */
@media (max-width: 768px) {
  .scorecard-meta {
    padding: 12px 18px;
  }
  
  .meta-item {
    gap: 2px;
  }
  
  .meta-label {
    font-size: 11px;
  }
  
  .meta-value {
    font-size: 15px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/Scorecard.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,6DAA6D;EAC7D,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,yCAAyC;EACzC,0CAA0C;AAC5C;;AAEA;EACE,6DAA6D;EAC7D,2CAA2C;AAC7C;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,yCAAyC;EACzC,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,6BAA6B;EAC7B,qCAAqC;EACrC,kBAAkB;EAClB,mBAAmB;EACnB,2CAA2C;EAC3C,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,+BAA+B;EAC/B,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,qCAAqC;EACrC,kBAAkB;EAClB,mBAAmB;EACnB,0CAA0C;EAC1C,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,iDAAiD;AACnD;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,mCAAmC;EACnC,gBAAgB;EAChB,mBAAmB;EACnB,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,mCAAmC;EACnC,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,qCAAqC;EACrC,2BAA2B;EAC3B,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY,EAAE,yDAAyD;EACvE,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,2BAA2B;EAC3B,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,yCAAyC;EACzC,sBAAsB;EACtB,aAAa;EACb,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;EAC5B,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,cAAc;EACd,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,0CAA0C;EAC1C,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,wCAAwC;EACxC,yBAAyB;AAC3B;;AAEA;EACE,6DAA6D;EAC7D,cAAc;EACd,8CAA8C;EAC9C,qBAAqB;AACvB;;AAEA;EACE,0CAA0C;EAC1C,cAAc;EACd,0CAA0C;AAC5C;;AAEA;EACE,6DAA6D;EAC7D,cAAc;EACd,YAAY;AACd;;AAEA;EACE,6DAA6D;EAC7D,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,qBAAqB;EACrB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,yBAAyB;EACzB,6CAA6C;EAC7C,qBAAqB;AACvB;;AAEA;EACE,6DAA6D;EAC7D,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;EACE,wBAAwB;EACxB,4CAA4C;AAC9C;;AAEA;EACE,6DAA6D;EAC7D,6CAA6C;AAC/C;;AAEA;EACE,6DAA6D;EAC7D,6CAA6C;AAC/C;;AAEA,0CAA0C;AAC1C;EACE;IACE,kBAAkB;IAClB,sBAAsB;EACxB;;EAEA;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,sBAAsB;IACtB,SAAS;IACT,kBAAkB;EACpB;;EAEA;IACE,mBAAmB;IACnB,8BAA8B;IAC9B,WAAW;EACb;;EAEA;IACE,eAAe;IACf,oBAAoB;IACpB,+BAA+B;EACjC;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,mBAAmB;IACnB,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,kBAAkB;IAClB,eAAe;EACjB;AACF;;AAEA,8BAA8B;AAC9B;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF","sourcesContent":[".scorecard-container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  margin-top: 20px;\n  padding: 0 10px;\n}\n\n.scorecard {\n  background: linear-gradient(135deg, #0b2545 0%, #134e73 100%);\n  color: #ffffff;\n  padding: 30px 25px;\n  border-radius: 16px;\n  margin-bottom: 20px;\n  width: 100%;\n  max-width: 650px;\n  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3);\n  border: 1px solid rgba(255, 255, 255, 0.1);\n}\n\n.scorecard.night-mode {\n  background: linear-gradient(135deg, #1a1a1a 0%, #2d2d2d 100%);\n  border: 1px solid rgba(255, 255, 255, 0.05);\n}\n\n.scorecard-header {\n  margin-bottom: 25px;\n}\n\n.scorecard h2 {\n  text-align: center;\n  color: #f5a623;\n  font-size: 28px;\n  font-weight: 700;\n  margin-bottom: 20px;\n  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);\n  letter-spacing: 0.5px;\n}\n\n.scorecard-meta {\n  display: flex;\n  justify-content: space-around;\n  background: rgba(255, 255, 255, 0.08);\n  padding: 15px 20px;\n  border-radius: 10px;\n  border: 1px solid rgba(255, 255, 255, 0.15);\n  margin-bottom: 5px;\n}\n\n.meta-item {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 4px;\n}\n\n.meta-label {\n  font-size: 12px;\n  color: rgba(255, 255, 255, 0.7);\n  font-weight: 500;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.meta-value {\n  font-size: 16px;\n  font-weight: 700;\n  color: #f5a623;\n  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.3);\n}\n\n.scorecard-content {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.match-row {\n  background: rgba(255, 255, 255, 0.05);\n  padding: 16px 20px;\n  border-radius: 12px;\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  transition: all 0.3s ease;\n}\n\n.match-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 12px;\n  padding-bottom: 8px;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.1);\n}\n\n.match-header-simple {\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n  margin-bottom: 8px;\n}\n\n.match-date {\n  font-size: 13px;\n  color: rgba(255, 255, 255, 0.8);\n  font-weight: 500;\n}\n\n.point-diff {\n  font-size: 12px;\n  color: #f5a623;\n  font-weight: 600;\n  background: rgba(245, 166, 35, 0.2);\n  padding: 2px 8px;\n  border-radius: 12px;\n  border: 1px solid rgba(245, 166, 35, 0.3);\n}\n\n.match-teams {\n  display: grid;\n  grid-template-columns: 2fr auto 2fr;\n  align-items: center;\n  gap: 8px;\n}\n\n.match-row:hover {\n  background: rgba(255, 255, 255, 0.08);\n  transform: translateY(-2px);\n  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.2);\n}\n\n.team {\n  display: flex;\n  align-items: center;\n  min-width: 0; /* Allows flex items to shrink below their content size */\n  max-width: 100%;\n}\n\n.team-a {\n  justify-content: flex-end;\n  padding-right: 8px;\n}\n\n.team-b {\n  justify-content: flex-start;\n  padding-left: 8px;\n}\n\n.team-name {\n  font-weight: 600;\n  font-size: 12px;\n  line-height: 1.2;\n  max-width: 100%;\n  color: #ffffff;\n  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.3);\n  word-break: break-word;\n  hyphens: auto;\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n  text-align: center;\n}\n\n.team.winner .team-name {\n  color: #f5a623;\n  font-weight: 700;\n}\n\n.scores {\n  display: flex;\n  gap: 12px;\n  flex-shrink: 0;\n  align-items: center;\n  justify-content: center;\n}\n\n.scores span {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 36px;\n  height: 36px;\n  background-color: rgba(255, 255, 255, 0.9);\n  color: #0b2545;\n  font-weight: 700;\n  font-size: 16px;\n  border-radius: 8px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);\n  transition: all 0.3s ease;\n}\n\n.scores .winning-score {\n  background: linear-gradient(135deg, #f5a623 0%, #ff8c42 100%);\n  color: #ffffff;\n  box-shadow: 0 4px 12px rgba(245, 166, 35, 0.4);\n  transform: scale(1.1);\n}\n\n.night-mode .scores span {\n  background-color: rgba(255, 255, 255, 0.1);\n  color: #ffffff;\n  border: 1px solid rgba(255, 255, 255, 0.2);\n}\n\n.night-mode .scores .winning-score {\n  background: linear-gradient(135deg, #f5a623 0%, #ff8c42 100%);\n  color: #ffffff;\n  border: none;\n}\n\n.download-button {\n  background: linear-gradient(135deg, #4CAF50 0%, #45a049 100%);\n  color: white;\n  border: none;\n  padding: 14px 28px;\n  text-align: center;\n  text-decoration: none;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 16px;\n  font-weight: 600;\n  margin: 8px 0;\n  cursor: pointer;\n  border-radius: 12px;\n  transition: all 0.3s ease;\n  box-shadow: 0 4px 16px rgba(76, 175, 80, 0.3);\n  letter-spacing: 0.5px;\n}\n\n.download-button:hover {\n  background: linear-gradient(135deg, #45a049 0%, #3d8b40 100%);\n  transform: translateY(-2px);\n  box-shadow: 0 6px 20px rgba(76, 175, 80, 0.4);\n}\n\n.download-button:active {\n  transform: translateY(0);\n  box-shadow: 0 2px 8px rgba(76, 175, 80, 0.3);\n}\n\n.night-mode .download-button {\n  background: linear-gradient(135deg, #45a049 0%, #3d8b40 100%);\n  box-shadow: 0 4px 16px rgba(69, 160, 73, 0.4);\n}\n\n.night-mode .download-button:hover {\n  background: linear-gradient(135deg, #4CAF50 0%, #45a049 100%);\n  box-shadow: 0 6px 20px rgba(76, 175, 80, 0.5);\n}\n\n/* Responsive design for smaller screens */\n@media (max-width: 480px) {\n  .scorecard {\n    padding: 20px 15px;\n    margin: 0 5px 20px 5px;\n  }\n  \n  .scorecard h2 {\n    font-size: 24px;\n    margin-bottom: 15px;\n  }\n  \n  .scorecard-meta {\n    flex-direction: column;\n    gap: 12px;\n    padding: 12px 15px;\n  }\n  \n  .meta-item {\n    flex-direction: row;\n    justify-content: space-between;\n    width: 100%;\n  }\n  \n  .meta-label {\n    font-size: 11px;\n    text-transform: none;\n    color: rgba(255, 255, 255, 0.8);\n  }\n  \n  .meta-value {\n    font-size: 14px;\n  }\n  \n  .match-row {\n    padding: 12px 15px;\n  }\n  \n  .match-header {\n    margin-bottom: 10px;\n    padding-bottom: 6px;\n  }\n  \n  .match-header-simple {\n    margin-bottom: 6px;\n  }\n  \n  .match-date {\n    font-size: 12px;\n  }\n  \n  .point-diff {\n    font-size: 11px;\n    padding: 2px 6px;\n  }\n  \n  .team-name {\n    font-size: 11px;\n  }\n  \n  .scores span {\n    width: 32px;\n    height: 32px;\n    font-size: 14px;\n  }\n  \n  .team-a {\n    padding-right: 6px;\n  }\n  \n  .team-b {\n    padding-left: 6px;\n  }\n  \n  .match-teams {\n    gap: 6px;\n  }\n  \n  .download-button {\n    padding: 12px 24px;\n    font-size: 15px;\n  }\n}\n\n/* Medium screen adjustments */\n@media (max-width: 768px) {\n  .scorecard-meta {\n    padding: 12px 18px;\n  }\n  \n  .meta-item {\n    gap: 2px;\n  }\n  \n  .meta-label {\n    font-size: 11px;\n  }\n  \n  .meta-value {\n    font-size: 15px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
